// @flow
import * as React from "react";

import { Button, Space } from "antd";

import AuthService from "services/auth";

import Navigation from "./Navigation";
import SearchBar from "./SearchBar";
import AffiliateBalance from "./ProfileLink/AffiliateBalance";
import ThemeToggle from "./ThemeToggle";
import UserMenu from "./UserMenu";

const MANAGER_ROLES = new Set(["adm", "him", "ham", "inm", "afm"]);

const Navbar = {
  LoggedIn(): React.Node {
    const claims = AuthService.getClaims();

    return (
      <>
        <ul className="navbar-nav nav-pills">
          <Navigation claims={claims} />
        </ul>
        <ul className="navbar-nav ms-auto align-items-center">
          {MANAGER_ROLES.has(claims.rol) && (
            <li className="nav-item">
              <SearchBar />
            </li>
          )}
          {claims.rol === "aff" && (
            <li className="nav-item">
              <AffiliateBalance />
            </li>
          )}
          <ThemeToggle />
          <UserMenu />
        </ul>
      </>
    );
  },
  LoggedOut(): React.Node {
    return (
      <ul className="navbar-nav ms-auto align-items-center">
        <ThemeToggle />
        <li className="nav-item">
          <Space>
            <Button href="/login">Log in</Button>
            <Button href="/signup" color="primary" variant="solid">
              Sign up
            </Button>
          </Space>
        </li>
      </ul>
    );
  },
};

export default Navbar;
